/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetIconContainer_widget$ref: FragmentReference;
declare export opaque type WidgetIconContainer_widget$fragmentType: WidgetIconContainer_widget$ref;
export type WidgetIconContainer_widget = {|
  +id: string,
  +type: ?string,
  +visible: ?boolean,
  +$refType: WidgetIconContainer_widget$ref,
|};
export type WidgetIconContainer_widget$data = WidgetIconContainer_widget;
export type WidgetIconContainer_widget$key = {
  +$data?: WidgetIconContainer_widget$data,
  +$fragmentRefs: WidgetIconContainer_widget$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetIconContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "visible",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bdfef46af212213efb1aef4c634d4a8a';
module.exports = node;
